import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import type {IJSONProvider} from "data/providers/json/json.provider";
import {Bindings} from "data/constants/bindings";
import {PlayerPosition, PlayerHand, PlayerStatus, PlayerGamePosition} from "data/enums";
import {keyBy} from "lodash";

export interface IPlayer {
	id: number;
	feedId: number;
	position: PlayerPosition;
	gamePosition: PlayerGamePosition;
	squadId: number;
	firstName: string;
	lastName: string;
	batHand: PlayerHand;
	pitchHand: PlayerHand;
	age: number;
	jerseyNumber: number | null;
	status: PlayerStatus;
	isLocked: boolean;
}

export interface IPlayersStore {
	get getIsLoading(): boolean;
	get list(): IPlayer[];
	get listById(): Record<number, IPlayer>;

	getPlayerById(playerId: number): IPlayer | undefined;
	fetchPlayers(): Promise<void>;
}

@injectable()
export class PlayersStore implements IPlayersStore {
	@observable private _isLoading: boolean = false;

	constructor(@inject(Bindings.JSONProvider) private _jsonProvider: IJSONProvider) {
		makeAutoObservable(this);
	}

	@observable private _list: IPlayer[] = [];

	get list() {
		return this._list;
	}

	get listById(): Record<number, IPlayer> {
		return keyBy(this._list, "id");
	}

	get getIsLoading(): boolean {
		return this._isLoading;
	}

	getPlayerById(playerId: number): IPlayer | undefined {
		return this.listById[playerId];
	}

	@action
	async fetchPlayers() {
		const {data} = await this._jsonProvider.players();

		runInAction(() => {
			this._list = data.items;
		});
	}
}
